// Test IDs for the AllergyPicker (multi-select + search bottom sheet). Keys
// camelCase, values kebab-case — see auth.js.
//
// `trigger` keeps its pre-existing value ("input-allergy") for e2e continuity:
// it used to be the free-text field's testid and the sheet replaces that field
// in place.
//
// Catalog keys (e.g. `tree_nuts`) use underscores to match the i18n namespace;
// testid values must stay kebab-case, so `kebab()` swaps them at the point the
// id is built rather than touching the catalog key itself.

const kebab = (key) => String(key).replace(/_/g, '-');

export const ALLERGY = {
	trigger: 'input-allergy',
	chip: (key) => `allergy-chip-${kebab(key)}`,
	sheet: 'allergy-sheet',
	search: 'allergy-search',
	option: (key) => `allergy-option-${kebab(key)}`,
	done: 'allergy-done',
};
